import { registerPlugin } from '@capacitor/core';

// Plugin Android. La mayoría de las térmicas de 58 y 80 mm hablan Bluetooth
// clásico (puerto serie, SPP) o USB, y ninguno de los dos llega al WebView:
// el plugin de BLE no las ve y WebUSB no existe dentro de una app.
//
// Métodos:
//   listarBluetooth()                     → { dispositivos: [{ direccion, nombre, impresora }] }  (las ya emparejadas)
//   abrirAjustesBluetooth()               → abre los ajustes del sistema para emparejar
//   conectarBluetooth({ direccion })      → { nombre }
//   listarUsb()                           → { dispositivos: [{ vendorId, productId, nombre, impresora }] }
//   conectarUsb({ vendorId, productId, pedirPermiso? }) → { nombre }
//   escribir({ datos })                   → datos en base64 (ESC/POS)
//   desconectar()
//   estado()                              → { conectado, transporte: 'bt' | 'usb' | null, nombre }
export const GcPrinter = registerPlugin('GcPrinter');

// Plugin Android del aparato (mismo paquete nativo):
//   mantenerEncendida({ encendida })  → la pantalla no se apaga (caja principal)
// Además, al cargar, recupera la pantalla si el proceso del WebView se cae.
export const GcAparato = registerPlugin('GcAparato');

// Plugin Android para actualizar la app sin Play Store:
//   info()                                   → { versionCode, versionName, puedeInstalar }
//   descargar({ url, sha256, versionCode })  → baja el APK y verifica su huella; evento "progreso" { recibidos, total }
//   instalar({ versionCode })                → abre el instalador de Android (o el ajuste del permiso: código PERMISO)
export const GcActualizador = registerPlugin('GcActualizador');
